<template>
  <div class="">
    <div class="mb-3 mt-3 " v-if="shoppingCart != 0">
      <div class="container"
           v-if="shoppingCart != null ">
        <div class="alert text-white alert-success text-center" v-t="'transaction.verify_success'">

        </div>

        <MetaManager1 :metas="shoppingCart.meta"/>

        <transaction-info class="bg-white" :item="shoppingCart.transaction"/>

        <user-info :info="shoppingCart"/>

        <order-items class="p-0 m-0" :items="shoppingCart.items"/>

        <summarize-order :info="shoppingCart"/>


      </div>
      <div class="container" v-if="shoppingCart == null  ">
        <div class="alert alert-danger text-center" role="alert" v-t="'transaction.verify_fail'">

        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import router from "@/router";
import TransactionInfo from "../FactorGeneralInfo/TransactionInfo/TransactionInfo1";
import OrderItems from "../FactorGeneralInfo/OrderItem/OrderItems1";
import UserInfo from "../FactorGeneralInfo/UserInfo/UserInfo1";
import SummarizeOrder from "../FactorGeneralInfo/SummerizeOrder/SummarizeOrder1";
import MetaManager1 from "../FactorGeneralInfo/Meta/MetaManager1.vue";


export default {
  name: "VerifyTransaction",
  components: {OrderItems, UserInfo, SummarizeOrder, TransactionInfo, MetaManager1},
  data() {
    return {
      shoppingCart: 0
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated'
    })
  },
  async mounted() {
    if (process.env.NODE_ENV != 'development') {
      const slug = this.$route.params.slug;
      await this.$store.dispatch("Transaction/verifyTransactionWithoutState", slug).then(res => {
        this.shoppingCart = res.data.data;
        localStorage.removeItem('products')
      }).catch(e => {
        this.shoppingCart = null
      });
    }
  },
};
</script>
<style scoped>

.bg-light-primary {
  background: var(--light-primary) !important;
}

</style>